import { MaybeTranslatable } from '@fmnts/api/shared';
import { Adapter } from '@fmnts/core';
import { IFieldCondition } from '../api-model/condition';

export interface FormNavigation {
  readonly key: string;
  readonly widget: string | undefined;
  readonly action: string;
  readonly label: MaybeTranslatable<string>;
  readonly style: string | undefined;
  readonly condition: IFieldCondition | undefined;
}

export class FormNavigationAdapter implements Adapter<FormNavigation> {
  adapt(item: Record<string, any>): FormNavigation {
    return {
      key: item['key'],
      widget: item['widget'],
      action: item['action'],
      label: item['label'],
      style: item['style'],
      condition: item['condition'],
    };
  }
}
